module.exports = __webpack_public_path__ + "static/media/service_one_to_one.7c58c981.png";